import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import CircularLoading from '../../common/components/circularLoading';
import LoginPage from '../../features/auth/pages/loginPage';
import Logout from '../../features/auth/pages/logout';
import AuthenticatedApp from './components/authenticated-app';
import ProtectedRoutes from './components/protected-routes';

const MainRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          caseSensitive
          path="/logout"
          element={
            <Suspense fallback={<CircularLoading text="Cargando" />}>
              <Logout />
            </Suspense>
          }
        />
        <Route
          caseSensitive
          path="/login"
          element={
            <Suspense fallback={<CircularLoading text="Cargando" />}>
              <LoginPage />
            </Suspense>
          }
        />
        <Route path="/*" element={<ProtectedRoutes Component={AuthenticatedApp} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MainRouter;
